import { Base64 } from 'js-base64'

export function base64Encrypt(data) {
  return Base64.encode(data.toString())
}